import ChatItem from "./Item";
import { StyledDiv, StyledPara } from "./style";
import { format, parse } from "date-fns";

const DateGroup = ({ dateGroup }) => {
  if (dateGroup && Array.isArray(dateGroup.data)) {
    return (
      <StyledDiv>
        <StyledPara>
          <span className="bg-white p-2 rounded-full shadow-1">
            {format(
              parse(dateGroup.dateGroup, "dd-MM-yyyy", new Date()),
              "d MMM yyyy"
            )}
          </span>
        </StyledPara>
        {dateGroup.data.map((item, index) => (
          <ChatItem key={index} item={item} />
        ))}
      </StyledDiv>
    );
  }
  return <div />;
};

export default DateGroup;
